import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/tooltip/index.js
// module id = 158
// module chunks = 0